export interface FeedbackProps {
  id: string;
  title: string;
  content: string;
  name: string;
  amount: string;
  status: string;
}

export const firstFeedbacks: FeedbackProps[] = [
  {
    id: '1',
    title: '생각지도 못한 부분을 찾아주셔서 감사합니다.',
    content: '생각지도 못한 부분을 찾아주셔서 감사합니다',
    name: '(주)예지*',
    amount: '4,021,540원',
    status: '환급완료',
  },
  {
    id: '2',
    title: '모르고있던 세금환급받아서 좋아요',
    content: '모르고있던 세금환급 받아서 좋아요',
    name: '여현*',
    amount: '4,864,450원',
    status: '환급완료',
  },
  {
    id: '3',
    title: '기대하지 않았는데, 환급이 진짜 되네요.',
    content: '환급받을 수있어 좋았어요.',
    name: '신은*',
    amount: '4,280,900원',
    status: '환급완료',
  },
  {
    id: '4',
    title: '일한다고 바쁜데 대신해주니 감사했네요',
    content: '쉬는날없이 일하다보니 대신 알아서 다해주시니 할만했네요.',
    name: '유경*',
    amount: '6,834,390원',
    status: '환급완료',
  },
  {
    id: '5',
    title: '전체적으로 좋았습니다.',
    content: '업무처리 및 진행상황 안내 등 전체적으로 좋았습니다.',
    name: '(주)엔유**',
    amount: '9,746,650원',
    status: '환급완료',
  },
  {
    id: '6',
    title: '몰라서 환급 못받을걸  쉽게 해결해줌',
    content: '세원이엔지  모르고 지날뻔한 환급금 쉽고 간단하게 처리해주심!요즘같이 자금  없을때 요긴하게  썻네요!',
    name: '한경*',
    amount: '14,163,350원',
    status: '환급완료',
  },
  {
    id: '7',
    title: '생각보다 절차가 간편해서 좋았습니다',
    content: '세금이 환급되니 좋구요  절차도 간단한것같아요',
    name: '심경*',
    amount: '9,393,000원',
    status: '환급완료',
  },
  {
    id: '8',
    title: '처음에는 긴가민가 했는데 환급 받았어요',
    content: '요즘 보이스피싱도 많고 해서 의심도 들었는데 신속한 응대와 전문성에 믿음이가서 신청했고 비수기 운영에 큰 도움받았습니다',
    name: '송지*',
    amount: '11,761,030원',
    status: '환급완료',
  },
  {
    id: '9',
    title: '개인사업자 입장에서 보탬이 되어서. 좋았습니다',
    content: '개인사업자 입장에서 보탬이 되어서. 좋았습니다',
    name: '김*환',
    amount: '5,450,730원',
    status: '환급완료',
  },
  {
    id: '10',
    title: '모르면 못찾을 세금, 수수료 아깝지 않네요.',
    content: '돌려받을수 있는 세금이 있는줄 몰랐는데 생각보다 많은 금액이 환급되어 놀랐습니다.  모르면 없어질 돈이였네요',
    name: '곽희*',
    amount: '2,005,360원',
    status: '환급완료',
  },
]

export const secondFeedbacks: FeedbackProps[] = [
  {
    id: '1',
    title: '개인사업자들 몰랐던 부분을 찾아서 일처리를 해주심에 감사합니다',
    content: '전혀 몰랐던 부분을 찾아서 일처리를 해주심에 감사합니다',
    name: '임성*',
    amount: '3,882,930원',
    status: '환급완료',
  },
  {
    id: '2',
    title: '모르고 있던 환급금을 찾게해주셔서',
    content: '추가 서류없이 환급을 받을수 있는게 좋았습니다.',
    name: '박영*',
    amount: '3,501,990원',
    status: '환급완료',
  },
  {
    id: '3',
    title: '이렇게 많은 돈이 생길줄은',
    content: '감사합니다',
    name: '이대*',
    amount: '10,094,530원',
    status: '환급완료',
  },
  {
    id: '4',
    title: '빠진것들 잘 신청해준거 같네요',
    content: '다음에도 이용할께요',
    name: '백이*',
    amount: '15,995,490원',
    status: '환급완료',
  },
  {
    id: '5',
    title: '답변이 느리지만 친절했어요',
    content: '잘해주셔서 환급더받아 좋네요^^',
    name: '김민*',
    amount: '9,038,740원',
    status: '환급완료',
  },
  {
    id: '6',
    title: '걱정 없다고는 하지만 주변에서는 세무 관련 되어서 걱정이 많았습니다',
    content: '5 년후에 다시 만났으면 좋겠습니다',
    name: '권영*',
    amount: '20,159,700원',
    status: '환급완료',
  },
  {
    id: '7',
    title: '빠른일처리 꼼꼼한 일처리',
    content: '깊은배려 너무나 감사드립니다.',
    name: '박석*',
    amount: '6,333,580원',
    status: '환급완료',
  },
  {
    id: '8',
    title: '모르고 지나쳤을 세금환급을 할수있어서 너무 좋습니다.',
    content: '모르고 지나쳤을 세금환급을 할수있어서 너무 좋습니다.',
    name: '모승*',
    amount: '7,101,180원',
    status: '환급완료',
  },
  {
    id: '9',
    title: '그냥 최고입니다.',
    content: '간편하고 편리함',
    name: '김태*',
    amount: '23,427,410원',
    status: '환급완료',
  },
  {
    id: '10',
    title: '생각보다 절차가 간편해서좋았습니다.',
    content: '세금이 환급되니 좋구요  절차도 간단한것같아요.',
    name: '심경*',
    amount: '9,393,000원',
    status: '환급완료',
  },
]
